


import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/slice";
import { Bell, X, MessageCircle, AlertTriangle, CheckCircle } from "lucide-react";
import logo from "../../assets/avanaval1.png";
import "../../styles/layout.css";
import "../../styles/notifications.css";
import { getWithTokenAPI, putWithTokenAPI } from "../../util/Api";
import { IoMdNotificationsOutline } from "react-icons/io";
import { Clock } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoPersonCircleOutline } from "react-icons/io5";
import { Button } from "../ui/button";
import { Languages } from "lucide-react"; // Or your icon library
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { setAdminData } from "../../redux/admindaetails";
const Topbar = ({ title = "Avan Aval" }) => {
  const dispatch = useDispatch();
  const token = localStorage.getItem('matrimony_token');
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const dropdownRef = useRef(null);

  const { t } = useTranslation();
  const unreadCount = notifications.filter(n => n.unread).length;
  const [toggle, setToggle] = useState(false);
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState("en");
  useEffect(() => {
    const fetchAllDetails = async () => {
      try {
        const response = await getWithTokenAPI(
          token,
          `/notification/find-particular?type=admin`
        );

        const getTimeAgo = (dateString) => {
          const now = new Date();
          const created = new Date(dateString);
          const diffInSeconds = Math.floor((now - created) / 1000);

          if (diffInSeconds < 60) return `${diffInSeconds} sec ago`;
          const diffInMinutes = Math.floor(diffInSeconds / 60);
          if (diffInMinutes < 60) return `${diffInMinutes} min ago`;
          const diffInHours = Math.floor(diffInMinutes / 60);
          if (diffInHours < 24) return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
          const diffInDays = Math.floor(diffInHours / 24);
          if (diffInDays === 1) return "Yesterday";
          return `${diffInDays} days ago`;
        };
        const lang = i18n.language === "en" ? "en" : "ta";
        if (response && Array.isArray(response.data)) {
          const formattedNotifications = response.data.map((item) => ({
            id: item._id,
            title: item.heading[lang] || "Notification",
            message: item.content[lang] || "No content available",
            time: getTimeAgo(item.createdAt),
            unread: !item.is_read,
          }));

          setNotifications(formattedNotifications);
        } else {
          setNotifications([]);
        }

      } catch (error) {
        console.error("Error fetching notifications:", error);
        setNotifications([]); // fallback
      }
    };

    fetchAllDetails();
  }, [i18n.language],);


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const location = useLocation();
  const navigate = useNavigate();



  const markAsRead = async (id) => {
    try {
      setNotifications((prev) =>
        prev.map((n) =>
          n.id === id ? { ...n, unread: false } : n
        )
      );
      const response = await putWithTokenAPI(
        token,
        `/notification/update?_id=${id}&is_read=true`
      );
      if (response.statusCode === 200) {
        const redirectPath = response?.data[0]?.redirect_path;
        if (redirectPath === "/payments") {
          navigate("/admin/payment-list");
          setOpen(false)
        }
        else if (redirectPath === "/Content Approvals") {
          navigate("/admin/content-approvals");
          setOpen(false)
        }
        else if (redirectPath === "/usermanagement") {
          navigate("/admin/user-management");
          setOpen(false)
        }
        else if (redirectPath === "/reports") {
          navigate("/admin/reports-moderation");
          setOpen(false)
        }
      }

    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };


  const getAllNotification = async () => {
    try {
      const response = await getWithTokenAPI(token, '/notification/find-particular?type=admin&notification_type=notification')
      console.log('getAllNotification', response);

    } catch (error) {

    }
  }

  useEffect(() => {
    getAllNotification()
  }, [])



  const changeLanguage = () => {
    const newLang = currentLang === "en" ? "ta" : "en";
    i18n.changeLanguage(newLang);
    setCurrentLang(newLang);
  };
  const buttonStyles = {
    default: {
      padding: "8px 20px",
      borderRadius: "30px",
      border: "none",
      cursor: "pointer",
      color: "#fff",
      fontWeight: "700",
      fontSize: "14px",
      letterSpacing: "0.5px",
      transition: "all 0.3s ease",
      position: "relative",
      overflow: "hidden"
    },
    primary: {
      background: "linear-gradient(135deg, #6a11cb, #2575fc)",
      boxShadow: "0 5px 15px rgba(0,0,0,0.2), inset 0 -2px 4px rgba(255,255,255,0.2)"
    },
    secondary: {
      background: "linear-gradient(135deg, #ff7e5f, #feb47b)",
      boxShadow: "0 5px 15px rgba(0,0,0,0.2), inset 0 -2px 4px rgba(255,255,255,0.2)"
    },
    hover: {
      transform: "scale(1.1)",
      boxShadow: "0 8px 20px rgba(0,0,0,0.25), inset 0 -2px 6px rgba(255,255,255,0.3)"
    }
  };
  const currentStyle = toggle ? buttonStyles.secondary : buttonStyles.primary;

const admin = useSelector((state) => state.admin.data);   // 🔥 redux data
const [localAdmin, setLocalAdmin] = useState({});

  console.log(admin, "admin")
  const fetchAdmin = async () => {
    const adminId = localStorage.getItem('matrimony_userId');
    try {
      const res = await getWithTokenAPI(token, `/admin/get_by_id/${adminId}`);
      setLocalAdmin(res.data);     
      dispatch(setAdminData(res.data));
    } catch {
    }
  };

 useEffect(() => {
    if (!admin?._id) {       
        fetchAdmin();
    } else {
        setLocalAdmin(admin); 
    }
}, []);

  return (
    <>
      <div className="admin-topbar-main">
        {/* Logo on Left End */}
        <div className="admin-logo-left"
          style={{
            cursor: "pointer"
          }}
          onClick={() => {
            navigate("/admin/dashboard")
          }}>
          <img
            src={logo}
            alt="Avan Aval Logo"
            className="admin-logo-image"
          />
          <h1 className="admin-logo-text">அவன் அவள்</h1>
        </div>

        <Button
          variant="ghost"
          size="sm"
          onClick={changeLanguage}
          className="avan-avala-language-btn hidden md:flex items-center space-x-1 text-gray-600 cursor-pointer 
             transition-transform duration-200 ease-in-out hover:text-orange-500 hover:scale-105 active:scale-95"
        >
          <Languages className="w-4 h-4" />
          <span className="avan-avala-language-text text-sm font-medium">
            {currentLang === "en" ? "தமிழ்" : "English"}
          </span>
        </Button>

        <div className="notification-wrapper" ref={dropdownRef}>

          <button
            className="notification-btn"
            onClick={() => setOpen(!open)}
          >
            <IoMdNotificationsOutline className="notification-icon-new" />
            {unreadCount > 0 && (
              <span className="notification-count">
                {/* {unreadCount > 9 ? '9+' : unreadCount} */}
                {unreadCount}
              </span>
            )}
          </button>
        </div>
        <div
          onClick={() => navigate("/admin/profile")}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "6px 10px",
            borderRadius: "8px",
            background: "#ffffff",
            cursor: "pointer",
            transition: "0.3s",
          }}
        >

          {admin?.profileImage ? (
            <img
              src={admin.profileImage}
              alt="admin"
              style={{
                width: "35px",
                height: "35px",
                borderRadius: "50%",
                objectFit: "cover",
                border: "2px solid #61616aff"
              }}
            />
          ) : (
            <IoPersonCircleOutline
              size={35}
              style={{ color: "#4b5563" }}
            />
          )}

          <p style={{
            margin: 0,
            fontSize: "14px",
            fontWeight: "600",
            color: "#111827",
            textTransform: "capitalize"
          }}>
            {admin?.name ?? "Admin"}
          </p>

        </div>

      </div>

      <div className="notification-wrapper" ref={dropdownRef}>
        {open && (
          <>
            <div
              className="notification-backdrop"
              onClick={() => setOpen(false)}
            />

            <div className="notification-dropdown">
              <div className="dropdown-header">
                <span>{t("WebTitle.notifications")}</span>
                <div className="dropdown-header-actions">
                  <button
                    className="close-btn"
                    onClick={() => setOpen(false)}
                  >
                    <X className="w-5 h-5" />
                  </button>
                </div>
              </div>

              <div className="dropdown-body">
                {notifications.length > 0 ? (
                  notifications.map((notification) => (
                    <div
                      key={notification.id}
                      className={`notification-item ${notification.type} ${notification.unread ? 'unread' : ''}`}
                      onClick={() => markAsRead(notification.id)}
                    >
                      <div className="notification-content">
                        <p className="title">
                          {notification.title}
                          {notification.unread && (
                            <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                          )}
                        </p>
                        <p className="message">{notification.message}</p>
                        <span className="time">
                          <Clock className="w-3 h-3" />
                          {notification.time}
                        </span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-notifications">
                    <Bell className="no-notifications-icon" />
                    <p>No notifications yet</p>
                    <p className="text-xs">We'll notify you when something arrives</p>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Topbar;